import React, { useEffect } from 'react'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Games from './components/Games'
import Stories from './components/Stories'
import DrawColor from './components/DrawColor'
import Chat3D from './components/Chat3D'
import Home from './components/Home'
import PlayGames from './components/PlayGames'
import TalkyToonStoryPage from './components/StoryTime'
import CreateAndDrawPage from './components/CreateDraw'
import PuzzleCorner from './components/PuzzleCorner'
import TalkyToonRhythmPage from './components/MusicDance'
import LoginPage from './components/Login'
import RegisterPage from './components/Register'
import ParentControlPage from './components/ParntControl'
import LearningTipsPage from './components/LearningTips'
import SkillDevelopmentPage from './components/SkillDevelopment'
import ShopPage from './components/Shop/Shop'
import Dashboard from './components/Dashboard'
import StoryDetailPage from './components/StoryDetailPage'
import WhisperWoodsSoundMatch from './components/Games/WhisperWoodsSoundMatch'
import EmojiMatchMania from './components/Games/EmojiMatch'
import EchoQuestGame from './components/Games/EchoQuestGame'
import VibeRacerGame from './components/Games/VibeRacer'
import TwisterTalkGame from './components/Games/TwisterTalk'
import SubscriptionPage from './components/Subscription'
import AlphabetPage from './components/LearningHub/AlphabetPage'
import NumbersAndMathsPage from './components/LearningHub/NumbersAndMathsPage'
import ReadingAndPhonicsPage from './components/LearningHub/ReadingAndPhonicsPage'
import ScienceBasicsPage from './components/LearningHub/ScienceBasicsPage'
import LifeSkillsPage from './components/LearningHub/LifeSkillsPage'
import MoralStoriesPage from './components/Stories/moralstories'
import Moraldetailstory from './components/Stories/moraldetailstory'
import Workshop from './components/Events/Workshop'
import OurMissionPage from './components/OurMissionPage'
import ContactPage from './components/ContactPage'
import PrivacyPolicyPage from './components/PrivacyPolicyPage'
import TermsOfUsePage from './components/TermsOfUsePage'
import AnimalSoundExplorer from './components/AnimalsSound'
import SEOHandler from './components/SEOHandler'

// --- 1. ScrollToTop Component ---
// Must be a child of Router to access useLocation.
const ScrollToTop = () => {
  const { pathname } = useLocation()

  useEffect(() => {
    window.scrollTo(0, 0)
  }, [pathname])

  return null
}
// --------------------------------

// --- 2. Inner Component for Content and Navigation Logic ---
// This component must be a child of Router to access useLocation()
// and render the Routes/Navbar conditionally.
const AppContent = () => {
  const location = useLocation()
  const currentPath = location.pathname

  // Define the paths where the standard Navbar and Footer should be hidden.
  // I recommend adding login/register as well, as they are often full-page forms.
  const noNavPaths = ['/dashboard', '/login', '/register', '/parentcontrol', "/shop"]

  // Check if the current path starts with any path in the exclusion list.
  // Using startsWith handles sub-routes like /dashboard/settings.
  const showNavAndFooter = !noNavPaths.some((path) =>
    currentPath.startsWith(path),
  )

  return (
    <div className="flex flex-col min-h-screen bg-yellow-50">
      {/* Conditional Navbar Rendering */}
      {showNavAndFooter && <Navbar />}

      <div className="flex-1">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/games" element={<Games />} />
          <Route path="/stories" element={<Stories />} />
          <Route path="/moralstories" element={<MoralStoriesPage />} />
          <Route path="/draw" element={<DrawColor />} />
          <Route path="/chat" element={<Chat3D />} />
          <Route path="/playgames" element={<PlayGames />} />
          <Route path="/storytime" element={<TalkyToonStoryPage />} />
          <Route path="/createdraw" element={<CreateAndDrawPage />} />
          <Route path="/puzzlecorner" element={<PuzzleCorner />} />
          <Route path="/musicdance" element={<TalkyToonRhythmPage />} />
          <Route
            path="/playgames/whisperwoods"
            element={<WhisperWoodsSoundMatch />}
          />
          <Route path="/playgames/emojimatch" element={<EmojiMatchMania />} />
          <Route path="/playgames/echoquest" element={<EchoQuestGame />} />
          <Route path="/playgames/viberacer" element={<VibeRacerGame />} />
          <Route path="/playgames/twistertalk" element={<TwisterTalkGame />} />
          <Route path="/alphabet" element={<AlphabetPage />} />
          <Route path="/numbers" element={<NumbersAndMathsPage />} />
          <Route path="/phonics" element={<ReadingAndPhonicsPage />} />
          <Route path="/science" element={<ScienceBasicsPage />} />
          <Route path="/lifeskills" element={<LifeSkillsPage />} />
                    <Route path="/animals" element={<AnimalSoundExplorer />} />


          {/* Routes where the Navbar is hidden */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/parentcontrol" element={<ParentControlPage />} />
          <Route path="/subscription" element={<SubscriptionPage />} />

          {/* Other Routes */}
          <Route path="/learningtips" element={<LearningTipsPage />} />
          <Route path="/skilldevelopment" element={<SkillDevelopmentPage />} />
          <Route path="/shop" element={<ShopPage />} />
          <Route path="/workshops" element={<Workshop />} />
          <Route path="/mission" element={<OurMissionPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
                    <Route path="/terms" element={<TermsOfUsePage />} />


          <Route path="/story/:storyId" element={<StoryDetailPage />} />
          <Route path="/moralstories/:moralId" element={<Moraldetailstory />} />
        </Routes>
      </div>

      {/* Conditional Footer Rendering */}
      {showNavAndFooter && <Footer />}
    </div>
  )
}

// --- 3. Main App Component ---
// This component now only handles the top-level Router setup.
function App() {
  return (
    <Router>
      <ScrollToTop />
       <SEOHandler />
      <AppContent />
    </Router>
  )
}

export default App
